/**
 * Match a PO string against a PO pattern.
 *
 * Expects a PO pattern as a mix of the following characters:
 * - `1` or '+' (matches `[0-9]`)
 * - `A` or '@' (matches `[a-zA-Z]`)
 * - misc characters
 *
 * @param poPattern pattern to match against
 * @param poString string to match with the pattern
 * @returns whether the string matches the pattern
 */
export function matchPurchaseOrderWithPattern(poPattern: string, poString: string): boolean {
  const allowedDigits = '1234567890';
  const allowedCharacters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';

  if (poPattern.length !== poString.length) {
    return false;
  }

  let isMatching = true;
  for (let i = 0; i < poPattern.length && isMatching; i++) {
    if (poPattern[i] === '1' || poPattern[i] === '+') {
      isMatching = allowedDigits.includes(poString[i]);
    } else if (poPattern[i] === 'A' || poPattern[i] === '@') {
      isMatching = allowedCharacters.includes(poString[i]);
    } else {
      isMatching = poPattern[i] === poString[i];
    }
  }

  return isMatching;
}
